export default class APIPaths {
  static SIGN_IN = "/api/orguser/login";
  static SIGN_UP = "/api/orguser/signup";

  static CONSULTANT_SIGN_IN = `/api/consultant/login`;
  static CONSULTANT_FORGOT_PASSWORD = `/api/consultant/forgotpassword`;
  static CONSULTANT_FORGOT_PASSWORD_VALIDATE_TOKEN = `/api/consultant/validate_token`;
  static CONSULTANT_FORGOT_PASSWORD_CHANGE = `/api/consultant/savepassword`;

  static CLIENT_SIGN_IN = `/api/client/login`;
  static CLIENT_SIGN_UP = `/api/client/signup`;
  static GET_CLIENT = `/api/client/get`;
  static CLIENT_FORGOT_PASSWORD = `/api/client/forgotpassword`;
  static CLIENT_FORGOT_PASSWORD_VALIDATE_TOKEN = `/api/client/validate_token`;
  static CLIENT_FORGOT_PASSWORD_CHANGE = `/api/client/savepassword`;
  static GET_CONSULTANTS_FOR_CLIENT = `/api/consultants/name/list/`;
  static GET_ORGANIZATION_LIST = `/api/organizations/name/list`;

  static FORGOT_PASSWORD = "/api/orguser/forgotpassword";
  static FORGOT_PASSWORD_VALIDATE_TOKEN = "/api/orguser/validate_token";
  static FORGOT_PASSWORD_CHANGE = "/api/orguser/savepassword";
  static CHANGE_USER_PASSWORD = "/api/user/change_password";

  static GET_DEGREE_LIST = "/api/consultantDegrees/list";
  static GET_SPECIALIZATION_LISt = "/api/consultantSpecializations/list";

  static IMPORT_ZIP_FILE = "/api/upload-zip";

  static ADD_CONSULTANT = `/api/consultants/add`;
  static ADD_CONSULTANT_IMAGE = `/api/consultantImagesInfo/add`;
  static ADD_CONSULTANT_TIMING = `/api/addressTimings/add`;
  static UPDATE_CONSULTANT = `/api/consultants/update/`;
  static UPDATE_CONSULTANT_IMAGE = `/api/consultantImagesInfo/update/`;
  static UPDATE_CONSULTANT_ADDRESS = `/api/addresses/update/`;
  static UPDATE_CONSULTANT_TIMING = `/api/addressTimings/update/`;
  static GET_CONSULTANT_LIST = `/api/consultants/list`;
  static GET_CONSULTANT_BY_ID = `/api/consultant/get/`;
  static GET_ADDRESS_BY_ADDRESS_ID = `/api/address/get/`;
  static GET_CONSULTANT_IMAGE = `/api/consultantImages/get/consultant/imagetype`;
  static DELETE_CONSULTANT_IMAGE = `/api/consultantImagesInfo/delete/`;

  static GET_ORGANIZATION_DATA = `/api/organization/get`;
  static GET_LOGGED_IN_USER_DETAILS = `/api/get/logged_in_user/details`;

  static GET_ALL_APPOINTMENTS = `/api/appointments/list`;
  static GET_TODAYS_APPOINTMENTS = `/api/organization/appointments/`;
  static CREATE_CLIENT = `/api/clients/add`;
  static UPDATE_CLIENT = `/api/client/update`;
  static GET_AVAILABLE_TIMING = `/api/consultant/getAvailableSlots`;

  static GET_APPOINTMENT_BY_ID = `/api/appointment/get/`;
  static GET_APPOINTMENT_LIST_BY_USER = `/api/appointments/get/consultant`;
  static CREATE_APPOINTMENTS = `/api/appointments/add`;
  static UPDATE_APPOINTMENT = `/api/appointment/update`;

  static GET_PRESCRIPTION_BY_APPOINTMENT_ID = `/api/appointment/prescriptions/`;
  static CREATE_PRESCRIPTION = `/api/prescriptions/add`;
  static GET_CLIENT_DETAILS = `/api/client/get/`;
  static GET_CLIENT_BY_ID = `/api/client/get/`;
  static GET_CLIENT_LIST_BY_VALUE = `/api/clients/list`;

  static GET_COUNTRY_LIST = "/api/countries";
  static GET_STATES_LIST = "/api/states";
  static GET_DAYS_OF_WEEK = "/api/dayOfWeek/list";
  static GET_ADDRESS_LIST = "/api/addresses/list";
  static GET_TIMING_LIST = "/api/addressTiming/list/address/";
  static POST_ADD_ADDRESS = "/api/addresses/add";
  static GET_ADDRESS_AND_TIMING = "/api/address_with_timing/list/get";
  static POST_ADD_ADDRESS_AND_TIMING = "/api/address_with_timing/add";
  static PUT_UPDATE_ADDRESS_AND_TIMING = "/api/addresses_timing/update/";
  static DELETE_ADDRESS = "/api/address/delete/";

  static GET_APPOINTMENTS_BY_CONSULTANT_USER_NAME = `/api/appointments/get/consultant`;

  static GET_APPOINTMENTS_BY_CLIENT_USER_NAME = `/api/appointment/get/client/`;

  static GET_ALL_DISEASES = "/api/diseases/list";
  static GET_DISEASE_BY_CLIENT_ID = "/api/diseases/client/";
  static ADD_DISEASE = "/api/diseases/add";
  static DELETE_DISEASE_BY_ID = "/api/diseases/delete/";
  static GET_DISEASE_LIST = `/api/disease`;
  static ADD_NEW_DISEASE = `/api/custom/disease/add`;

  static UPLOAD_CLIENT_DOCUMENT = `/api/clientdocument/add`;
  static GET_CLIENT_ALL_DOCUMENT_LIST_BY_CLIENT_ID = `/api/clientdocument/list/`;
  static GET_CLIENT_CASE_PAPER_BY_APPOINTMENT_ID = `/api/clientCasePaperDocument`;
  static GET_CLIENT_IMAGE_DOCUMENT_BY_APPOINTMENT_ID = `/api/clientImageDocument`;
  static DELETE_CLIENT_DOCUMENT_BY_ID = `/api/clientdocument/delete/`;
  static GET_CLIENT_DOCUMENT_BY_ID = `/api/clientdocument/get/`;
  static SHARE_CLIENT_DOCUMENT = `/api/sharedocument/add`;

  static DOWNLOAD_PRESCRIPTION_PDF_BY_PRESCRIPTION_ID = `/api/client/prescription/download/`;
  static DOWNLOAD_INVOICE_PDF_BY_INVOICE_ID = `/api/client/invoice/download/`;
  static DOWNLOAD_PAYMENT_RECEIPT_PDF_BY_PAYMENT_ID = `/api/client/payment/receipt/download/`;

  static GET_PAYMENT_LIST = `/api/payments/list`;
  static GET_PAYMENT_LIST_BY_CLIENT_ID = `/api/client/payments/list/`;
  static DELETE_PAYMENT_BY_ID = `/api/payment/delete/`;
  static GET_INVOICE_LIST = `/api/invoices/list`;
  static GET_INVOICE_BY_ID = `/api/invoice/get/`;
  static CREATE_INVOICE = `/api/invoice/add`;
  static DELETE_INVOICE_BY_ID = `/api/invoice/delete/`;

  static ADD_PAYMENT = "/api/payment/add";
  static UPDATE_ORG = "/api/organizations/update";
  static GET_ORG_LOGO = "/api/organization/logo/";
  static GET_ORG_STAMP = "/api/organization/stamp/";
  static GET_ORG_SIGN = "/api/organization/sign/";

  static GET_INSTRUCTION_LIST = `/api/instruction`;
  static GET_DOSAGE_LIST = `/api/dosage`;
  static GET_MEDICINE_LIST = `/api/medicine`;
  static GET_BUSINESS_TYPE = `/api/business`;

  static GET_APPOINTMENTS_COUNT = `/api/numberof/appointments`;
  static GET_EARNING = `/api/earning`;

  static GET_CONSULTANT_ADDRESSES = "/api/get/consultant/addresses";
  static GET_IMAGE_TYPES = "/api/imageType/list";

  static GET_BILL_CODES = "/api/billcodes/list";
  static ADD_BILL_CODE = `/api/billcode/add`;
  static UPDATE_BILL_CODE = `/api/billcode/update`;
  static DELETE_BILL_CODE = `/api/billcode/delete`;

  static ADD_MEDICINE = `/api/medicine/add`;

  static ADD_CLIENTS_LIST = "/api/clients/list/add";
  static DOWNLOAD_SAMPLE_CSV = `/api/download/sample/csv`;

  static GET_EXERCISE_LIST = `/api/exercise`;
  static GET_EXERCISE_IMAGE = `/api/exerciseImage`;
  static GET_FREQUENTLY_USED_EXERCISES = `/api/frequentlyUsed/exercise/list`;
  static ADD_EXERCISE = `/api/exerciseImagesInfo/add`;
  static UPDATE_EXERCISE = `/api/exerciseImagesInfo/update`;
  static DELETE_EXERCISE = `/api/exerciseImage/delete`;

  static GET_ADMIN_USERS_LIST = `/api/adminUser/list`;
  static ADD_NEW_ADMIN_USER = `/api/adminUser/add`;
  static UPDATE_ADMIN_USER = `/api/adminUser/update/`;
  static DELETE_ADMIN_USER = `/api/adminUser/delete/`;

  static GET_PRESCRIPTION_LAYOUT_LIST = `/api/prescriptionLayout/list`;
  static UPDATE_PRESCRIPTION_LAYOUT = `/api/update/prescriptionLayout`;

  static GET_APPOINTMENTS_FOR_CONSULTANT_BY_DATE = `/api/consultant/appointments/list/`;
  static GET_CONSULTANT = `/api/consultant/get`;

  static GET_PRESCRIPTION_BACKGROUND_IMAGE = "/api/prescriptionBackgroundImage";

  static DOWNLOAD_EXERCISE_PRESCRIPTION = "/api/exercise/prescription/download";

  static GET_ALL_TEMPLATES = "/api/templates/list";

  static ADD_TEMPLATE = "/api/template/add";

  static UPDATE_TEMPLATE = "/api/template/update/";

  static GET_TEMPLATE_BY_ID = "/api/template/";

  static GET_TEMPLATE_EXERCISE_LIST_BY_NAME = "/api/templateName/";

  static DELETE_TEMPLATE = `/api/template/delete`;

  static ADD_CONSULTANT_FEEDBACK = `/api/consultantFeedBack/add`;

  static GET_CONSULTANT_FEEDBACK_BY_CONSULTANT_ID = `/api/consultantFeedBack/getBy/consultant`;

  static GET_DIAGNOSIS_SUGGESTION_LIST = "/api/diagnosis/getSuggestionList";
  static DIAGNOSIS_ADD = "/api/diagnosis/add";

  static ADD_REFERRER = "/api/referrer/add";
  static GET_REFERRER = "/api/referrers/searchedList";
  static UPDATE_REFERRER = "/api/referrer/update";
  static DELETE_REFERRER = `/api/referrer/delete`;
  static GET_REFERRER_BY_ID = "/api/referrer";

  static GENERATE_APPOINTMENT_DATES = "/api/generateAppointmentDates";
  static GET_REFERRER_FEES_BY_ID = "/api/referralCharge/total";

  static GET_ALL_PACKAGE = `/api/servicePacksList`;
  static GET_ALL_PREDEFINED_SERVICE_PACKS = "/api/predefinedServicePack/list";
  static GET_PACKAGES_BY_CLIENT_ID = `/api/servicePacksListByClientId`;

  static ADD_PACKAGE = `/api/predefinedServicePack/add`;
  static UPDATE_PACKAGE = `/api/predefinedServicePack/update`;
  static DELETE_PACKAGE = `/api/predefinedServicePack/delete`;

  static GET_CLIENT_AVAILABLE_BALANCE = `/api/creditWallet/info`;

  static DOWNLOAD_PAYMENT_FILE = `/api/download/paymentFile`;

  static DOWNLOAD_INVOICE_FILE = `/api/download/invoiceFile`;

  static GET_TREATMENT_LIST = `/api/getMedicalProcedures`;
  static GET_MEDICAL_PROCEDURE_ITEMS_LIST = `/api/getMedicalProcedureItemsList`;

  static GET_CONSULTANT_LIST_BY_ADDRESS_ID = `/api/consultants/list/`;

  static UPDATE_INVOICE = `/api/invoice/update`;

  static GET_COLOR_CODE = `/api/colorCode`;

  static DOSAGE_ADD = "/api/add/medicineDosage";
  static INSTRUCTION_ADD = "/api/add/medicineInstruction";

  static VALIDATE_COLOR_CODE = `/api/validate/colorCode`;

  static GET_BIRTHDAY_EMAIL_INFO = "/api/birthdayEmailInfo";

  static UPDATE_BIRTHDAY_EMAIL_INFO = "/api/update/birthdayEmailInfo";

  static ADD_NEW_TREATMENT_PLAN = `/api/medicalProcedure/add`;
  static UPDATE_TREATMENT_PLAN = `/api/medicalProcedure/update`;
  static GET_TREATMENT_PLAN_LIST = `/api/getAllTreatmentPlan/list`;
  static DELETE_TREATMENT_PLAN = `/api/medicalProcedure/delete/`;
  static GET_TREATMENT_PLAN_BY_ID = `/api/medicalProcedure/get/`;

  static GET_ALL_TEETH_INFO_LIST = "/api/getAllTeethInfo";

  static UPDATE_SERVICE_PACK = "/api/update/servicePack";

  static CALENDAR_CONSENT = "/api/oauth2callback";
  static IS_CONSULTANT_AUTHORIZE = "/api/checkCalendarAccess";
  static CONSULTANT_UNAUTHORIZE = "/api/removeCalendarAccess";

  static DOWNLOAD_INVOICE_REPORT = `/api/download/report/invoiceFile`;
  static DOWNLOAD_PAYMENT_REPORT = `/api/download/report/paymentFile`;
  static GET_TREATMENT_PLAN_BY_CLIENT_ID_CONSULTANT_ID =
    "/api/medicalProcedure/get/";
  static GET_TREATMENT_PLAN_BY_CLIENT_ID = "/api/client/medicalProcedure/get/";

  static UPDATE_PRESCRIBED_MEDICAL_PROCEDURE =
    "/api/prescribedMedicalProcedure/update/";

  static GET_CLIENT_CONSENT_PDF_INFO = "/api/consent/list";
  static ADD_CLIENT_CONSENT_FORM_INFO = "/api/consent/add";
  static UPDATE_CLIENT_CONSENT_FORM_INFO = "/api/consent/update";
  static DELETE_CLIENT_CONSENT_FORM_INFO = `/api/consent/delete`;

  static ACCEPT_CLIENT_CONSENT_FORM = "/api/consentAcceptance/acceptConsent";
  static GET_ACCEPTED_CONSENT_FORM_BY_CLIENT_ID =
    "/api/consentAcceptance/getConsentList";
  static GET_ACCEPTED_CONSENT_PDF_BY_ID = "/api/consentAcceptance/getPdf";
  static WITHDRAW_CONSENT_BY_ID = "/api/withdrawConsent";
  static SEND_OTP_TO_ACCEPT_CONSENT = "/api/consent/send-otp";
  static DOWNLOAD_CONSENT_FORM = "/api/consentForm/getFormPdf";

  static GET_ADDITIONAL_INFO_LIST_BY_ORG_ID = `/api/appointment/additional-info/`;
  static GET_CASE_PAPER_DEF_BY_ORGANIZATION_ID = `/api/casePaperDef/getall`;
  static SAVE_CASE_PAPER_ANSWER = `/api/casePaperAnswer/save`;
  static SEARCH_CASE_PAPER = "/api/casepaper/search";
  static GET_FIVE_CASE_PAPER_BY_ID = "/api/casepaper/previous5/get";
  static GET_CASE_PAPER_BY_CASE_PAPER_ID = "/api/casepaper/get/";
  static ADD_CASE_PAPER = "/api/casePaperDef/upload";
  static DOWNLOAD_SAMPLE_CASE_PAPER_ZIP_FOLDER = `/api/casePaper/download`;
  static DOWNLOAD_CASE_PAPER_DEF_CSV_BY_ID = `/api/casePaper/download/`;
  static DELETE_CASE_PAPER_DEF_CSV_BY_ID = `/api/casePaperDef/`;
  static GET_CASE_PAPER_DEF_LIST = `/api/casePaperDef/list`;
  static STATUS_CHANGE_CASE_PAPER_DEF_BY_ID = `/api/casePaperDef/status/`;
  static DOWNLOAD_CASE_PAPER_PDF_BY_CASE_PAPER_ID = `/api/casePaper/download-pdf/`;
  static GET_CASE_PAPER_BY_APPOINTMENT_ID = `/api/casepaper/appointment/get/`;
  static UPDATE_CASE_PAPER_DEF_NAME = `/api/casePaperDef/update-name`;
  static DELETE_ADDED_CASE_PAPER_BY_ID = `/api/casePaper/delete/`;

  static GET_DEFAULT_MEDICAL_PROCEDURES = "/api/default/medicalProcedures";
  static DELETE_APPOINTMENT = `/api/appointments/delete/`;

  static DELETE_CLIENT_BY_ID = `/api/client/delete/`;
  static DELETE_CONSULTANT_BY_ID = `/api/consultant/delete/`;
  static GET_TOTAL_APPOINTMENTS = `/api/appointment/graph/details`;
  static GET_TOTAL_CLIENTS = `/api/client/graph/details`;
  static DOWNLOAD_PDF_REPORT = `/api/report/pdf`;
  static DOWNLOAD_CSV_REPORT = `/api/report/csv`;

  static GET_APPOINTMENT_COUNT_BY_CLIENT_ID = `/api/appointment/count/`;
  static GET_MEDICINES_TO_BE_PAID_BY_CLIENT_ID_CONSULTANT_ID = `/api/medicine/toBePaid/`;

  static COPY_FROM_PREVIOUS_PRESCRIPTION =
    "/api/copyMedicinesFromPreviousPrescription/";

  static MERGE_CLIENT_RECORDS = "/api/merged/client";

  static UPLOAD_CLIENT_ADDITIONAL_INFO = "/api/upload/clientAdditionalInfo";

  static DOWNLOAD_SAMPLE_CLIENT_ADDITIONAL_INFO_CSV =
    "/api/download/sample/clientAdditionalInfo";

  static DOWNLOAD_CLIENT_ADDITIONAL_INFO_BY_ID =
    "/api/download/clientAdditionalInfoById/";

  static DELETE_CLIENT_ADDITIONAL_INFO_DEF_BY_ID =
    "/api/delete/clientAdditionalInfoDef/";

  static GET_ALL_VITAL_INFOS = "/api/get/vitalInfo";

  static ADD_VITAL_INFO = "/api/add/vitalInfo";

  static UPDATE_VITAL_INFO = "/api/update/vitalInfo";

  static DELETE_VITAL_INFO_BY_ID = "/api/delete/vitalInfo/";

  static GET_PATIENT_VACCINE_RECORDS_BY_CLIENT_ID = `/api/getAllPatientRecords`;

  static UPDATE_PATIENT_RECORDS = "/api/updatePatientVaccineRecords/";

  static CREATE_IMMUNIZATION_SCHEDULE = "/api/createImmunizationSchedule/";

  static DOWNLOAD_IMMUNIZATION_SCHEDULE_BY_CLIENT_ID =
    "/api/download/ImmunizationSchedule";

  static UPDATE_PATIENT_VACCINE_RECORD = "/api/updatePatientVaccineRecord";

  static GET_VACCINES_TO_BE_PAID_BY_CLIENT_ID = `/api/vaccines/toBePaid/`;

  static GET_ALL_VACCINE_RECORDS = `/api/getAll/vaccineSchedule`;

  static GET_DEFAULT_VACCINE_SCHEDULES = "/api/default/vaccineSchedules";

  static ADD_VACCINE_SCHEDULE_RECORD = "/api/add/vaccineScheduleRecord";

  static DELETE_VACCINE_SCHEDULE_RECORD_BY_ID =
    "/api/delete/vaccineScheduleRecord/";

  static UPDATE_VACCINE_SCHEDULE_RECORD = "/api/update/vaccineScheduleRecord/";

  static ADD_VACCINE_SCHEDUELE_TO_PATIENT_VACCINE_RECORD =
    "/api/add/vaccineScheduleToPatientVaccineRecord";

  static GET_INVOICE_GRAPH_DETAILS = "/api/invoice/graph/details";
  static GET_PAYMENT_GRAPH_DETAILS = "/api/payment/graph/details";
  static GENERATE_CSV_FOR_INVOICE_AND_PAYMENT_GRAPH =
    "/api/invoice/payment/graph/report/csv";

  static GET_GROWTH_CHART_DATA_BY_CLIENT_ID = "/api/growthChart/forClient/";

  static DOWNLOAD_GROWTH_CHART_PDF = "/api/download/growthChart/pdf/";

  static GET_MEDICINE_INFORMATION_LIST = `/api/medicineInfo/getall`;
  static UPDATE_MEDICINE_INFORMATION = `/api/medicineInfo/update`;
  static DELETE_MEDICINE_INFORMATION_BY_ID = `/api/medicineInfo/delete`;
  static IMPORT_DEFAULT_MEDICINE_INFO = "/api/medicineInfo/importDefault";
  static IMPORT_MEDICINE_INFO = "/api/medicine-info/import";
  static DOWNLOAD_SAMPLE_MEDICINE_INFO_CSV =
    "/api/medicine-info/download/sample/csv";

  static CREATE_MEDICINE_INFO_CATEGORY = "/api/medicineInfoCategory/create";
  static GET_ALL_MEDICINE_INFO_CATEGORY = "/api/medicineInfoCategory/get-all";
  static GET_MEDICINE_INFO_CATEGORY_BY_ID = "/api/medicineInfoCategory/get/";

  static SMS_ATTACHMENT_FILE = "/api/smsdoc";

  static CHANGE_APPOINTMENT_CONSULTANT = "/api/change/consultant/";

  static GET_ALL_CERTIFICATE_TEMPLATES = "/api/getAll/certificate/template";
  static ADD_CERTIFICATE_TEMPLATE = "/api/add/certificate/template";
  static UPDATE_CERTIFICATE_TEMPLATE = "/api/update/certificate/template/";
  static DELETE_CERTIFICATE_TEMPLATE = "/api/delete/certificate/template/";
  static DOWNLOAD_CERTIFICATE_TEMPLATE_PDF =
    "/api/generate/certificate/templatePdf/";
  static GENERATE_CERTIFICATE_FOR_CLIENT =
    "/api/generate/certificate/for/client";
  static GET_ALL_ACCEPTED_CERTIFICATES_BY_CLIENTID =
    "/api/get/certificates/for/client";
  static DOWNLOAD_CERTIFICATE_PDF_BY_ID = "/api/generate/certificate/";

  static ADD_QUESTION_OPTION = "/api/question/option";

  static GENERATE_CSV_OR_PDF_FOR_SERVICE_PACKAGE_BY_GIVEN_FILTERS =
    "/api/download/servicePackFile";

  static ADD_REFUND = "/api/refund/add";
  static UPDATE_REFUND = "/api/refund/update";
  static GET_ALL_REFUNDS = "/api/refunds/list";
  static DELETE_REFUND = "/api/delete/refund";
  static GET_ALL_REFUNDS_BY_SEARCH = "/api/refunds/list";
  static GET_ALL_INVOICES_BY_CLIENT = "/api/invoices/list/client";
  static GET_REFUNDS_BY_CLIENT_ID = `/api/client/refunds/list/`;

  static ADD_HOSPITALIZATION_RECORD = "/api/hospitalization/add";
  static UPDATE_HOSPITALIZATION_RECORD = "/api/hospitalization/update";
  static ADD_HOSPITALIZATION_ROOM = "/api/hospitalization/room/add";
  static DELETE_HOSPITALIZATION_RECORD_BY_ID = "/api/hospitalization/delete/";
  static GET_HOSPITALIZATION_LIST_BY_CLIENT_ID =
    "/api/hospitalization/get-all/";
  static GET_HOSPITALIZATION_RECORD_BY_ID = "/api/hospitalization/get/";
  static GET_ALL_HOSPITALIZATION_BY_ORG = "/api/hospitalization/org/get-all/";
  static ADD_CHECK_UP_RECORD = "/api/hospitalization/check-up/add";
  static UPDATE_CHECK_UP_RECORD = "/api/hospitalization/check-up/update";
  static GET_ALL_CHECK_UP_RECORD_BY_HOSPITALIZATION =
    "/api/hospitalization/check-up/get-all/";
  static GET_ALL_ROOMS_BY_HOSPITALIZATION =
    "/api/hospitalization/room/get-all/";
  static HOSPITALIZATION_ROOM_CHANGE = "/api/hospitalization/room/change";
  static MODIFY_HOSPITALIZATION_STATUS = "/api/hospitalization/update/status/";
  static GET_CONSULTANT_AVAILABLE_TIME_BY_DAY = "/api/consultant/";
  static ADD_INSURANCE = "/api/insurance/add";
  static UPDATE_INSURANCE = "/api/insurance/update/";
  static GET_PRESCRIPTION_BY_ID = "/api/prescription/get/";
  static GET_INSURANCE_BY_ID = "/api/insurance/get/";
  static CHANGE_INSURANCE_STATUS = "/api//insurance/change/status";
  static GET_HOSPITALIZATION_ROOM_BILL_ITEMS =
    "/api/hospitalization/room/bill-items/";
  static GET_ALL_HOSPITALIZATION_ROOM_TYPE =
    "/api/hospitalization/room/type/list";
  static UPDATE_HOSPITALIZATION_ROOM = "/api/hospitalization/room/update";
  static GET_ALL_HOSPITALIZATION_BY_CONSULTANT =
    "/api/hospitalization/consultant/get-all";
  static GET_ALL_INSURANCE_BY_HOSPITALIZATION =
    "/api/insurance/getall/hospitalization/";
  static DELETE_INSURANCE = "/api/insurance/delete/";
  static GET_ALL_CHECKUP_BILL_ITEMS =
    "/api/hospitalization-check-up/bill-code/";
  static FINISH_HOSPITALIZATION_CHECK_UP =
    "/api/hospitalization/check-up/finish/";

  static GET_ALL_MEDICAL_PRODUCT_BY_ORG = `/api/medicalProduct/getall`;
  static ADD_MEDICAL_PRODUCT = `/api/medicalProduct/add`;
  static UPDATE_MEDICAL_PRODUCT = `/api/medicalProduct/update`;
  static DELETE_MEDICAL_PRODUCT_BY_ID = `/api/medicalProduct/delete`;
  static GET_MEDICAL_PRODUCT_BY_ID = "/api/medicalProduct/get";
  static ADD_MEDICAL_PRODUCT_BATCH_BY_PRODUCT_ID = `/api/medicalProductBatch/add/`;
  static GET_ALL_MEDICAL_PRODUCT_BATCH_BY_PRODUCT_ID = `/api/medicalProductBatch/getall`;
  static UPDATE_MEDICAL_PRODUCT_BATCH_BY_ID = `/api/medicalProductBatch/update`;
  static DELETE_MEDICAL_PRODUCT_BATCH_BY_ID = `/api/medicalProductBatch/delete`;
  static GET_AVAILABLE_MEDICAL_PRODUCT_BY_MEDICINE = `/api/medicalProduct/available`;
  static GET_MEDICAL_PRODUCT_BILL_CODE = `/api/medicalProduct/bill-code`;
  static GET_ALL_ROLE = `/api/roles/list`;
  static GET_ALL_MEDICAL_PRODUCT_TRANSACTION = `/api/medicalProduct/transaction/getall`;
  static GET_MEDICAL_PRODUCT_TRANSACTION_REPORT = `/api/medicalProduct/transaction/report`;
  static IMPORT_MEDICAL_PRODUCT = `/api/medical-product/upload`;
  static IMPORT_MEDICAL_PRODUCT_BATCH = `/api/medical-product/batch/upload`;
  static DOWNLOAD_SAMPLE_MEDICAL_PRODUCT_CSV = `/api/download/sample/medicalProduct/csv`;
  static DOWNLOAD_SAMPLE_MEDICAL_PRODUCT_BATCH_CSV = `/api/download/sample/medicalProduct/batch/csv`;
  static GET_MEDICAL_PRODUCT_REPORT = `/api/medicalProduct/report`;
  static GET_ALL_UNITS = "/api/unit/get-all";
  static GET_ALL_UNIT_TYPES = "/api/unit-types";
  static GET_ALL_PARENT_UNIT_BY_CHILD_ID = "/api/unit/get/parent-unit";
  static GET_CONVERSION_FACTOR_UNITS = "/api/unit/conversion-factor/units";
  static GET_ALL_UNITS_BY_TYPE = "/api/unit/unit-type/getAll";
  static GET_DOSAGE_UNITS = "/api/unit/get-dosage-units";
  static CREATE_UNIT = "/api/unit/create";
  static GET_CONTENT_MEASUREMENT_UNITS_BY_DISPENSE_UNIT =
    "/api/unit/content-measurement/units";
  static SUGGEST_MEDICAL_PRODUCT_BATCH_BY_PRODUCT =
    "/api/medicalProduct/suggest";
  static GET_CONTENT_MEASUREMENT_UNIT_BY_PRODUCT =
    "/api/medicalProduct/content-measurement-unit/get";
  static ADD_FORM = "/api/product-form/add";
  static GET_ALL_FROMS = "/api/product-from/getall";
  static ADD_STORAGE_CONDITION = "/api/storage-condition/add";
  static GET_ALL_STORAGE_CONDITION = "/api/storage-condition/getall";
  static ADD_SIDE_EFFECT = "/api/side-effect/add";
  static GET_ALL_SIDE_EFFECT = "/api/side-effect/getall";

  static GET_ALL_VITAL_INFO_BY_CLIENT_ID = "/api/get/vitalInfo/";

  static GENERATE_CSV_OR_PDF_FOR_REFUND_REPORT =
    "/api/download/report/refundFile";
  static GENERATE_CSV_FOR_REFUND_GRAPH = "/api/refund/graph/report/csv";
  static GET_REFUND_GRAPH_DETAILS = "/api/refund/graph/details";

  static GET_VAS_SCALE_IMAGE_BY_ID = "/api/get/vasScaleImageById";

  static DOWNLOAD_COMBINED_CASE_PAPER_PDF_BY_CATEGORY =
    "/api/casePaper/download-combined-pdf";

  static GET_CASE_PAPERS_BY_CLIENT_ID = "/api/casePapers/client";

  static GET_ROM_RANGES_BY_JOINT_AND_MOTION = "/api/romRanges/";

  static ADD_EDUCATIONAL_MATERIAL = `/api/educationalMaterial/add`;
  static GET_ALL_EDUCATIONAL_MATERIAL = `/api/educationalMaterial/list`;
  static GET_EDUCATIONAL_MATERIAL_IMAGE = `/api/educationalMaterialImage`;
  static UPDATE_EDUCATIONAL_MATERIAL_BY_ID = `/api/educationalMaterial/update`;
  static DELETE_EDUCATIONAL_MATERIAL_BY_ID = `/api/educationalMaterial/delete`;
  static GET_EDUCATIONAL_MATERIAL_BY_IDS = `/api/educationalMaterial/listByIds`;

  static GET_ALL_HOLIDAYS = "/api/holiday/list";
  static ADD_HOLIDAY = "/api/holiday/add";
  static UPDATE_HOLIDAY = "/api/holiday/update";
  static DELETE_HOLIDAY = "/api/holiday/delete/";

  static DOWNLOAD_REFUND_RECEIPT_PDF_BY_REFUND_ID = `/api/client/refund/receipt/download/`;

  static GET_LAST_APPOINTMENT_REFERRER = "/api/appointment/last-referrer/";

  static APPOINTMENT_PROGRESS_REPORT = `/api/appointments/progress-report`;

}
